module.exports = __webpack_public_path__ + "static/img/button@2x.1d04cee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deceitimages/v1/button@2x.png
// module id = BKbX
// module chunks = 23